import { Component, OnInit, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { BrowserModule } from '@angular/platform-browser';
import { NgxMaskModule } from 'ngx-mask';
import { GlobalErrorHandler } from 'src/app/services/GloabalErrorHandler.services';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzAlertModule } from 'ng-zorro-antd/alert';


@Component({
    selector: 'app-authentication-form',
    templateUrl: './authentication-form.component.html',
    styleUrls: ['./authentication-form.component.scss'],
    standalone: false
})

export class AuthenticationFormComponent implements OnInit {

  currentYear = new Date().getFullYear();
  hide = true;
  user = {
    username: '',
    password: '',
    mfaCode: '',
    email: '',
    phone: ''
  };

  public enableImage:boolean = false;
  public options: UntypedFormGroup;
  public firebaseErrorMessage:string="";
  public credential = null;
  public loading = false;
  public show2FACodeInput = false;
  public showEmailPhone = false;
  public challengeName:string = "";
  public mfaSession = null;  

  customMask: [string];

  
  pattern = '^[1-9]{2}9[0-9]{1}[0-9]{3}[0-9]{4}$';  

  
  formSubmitAttempt: boolean;
  constructor(public  authService:  UserAuthenticationServices) {
    
    

    this.options = new UntypedFormGroup({
      username: new UntypedFormControl('', Validators.compose([Validators.required])),
      password: new UntypedFormControl('',Validators.compose([Validators.required,Validators.minLength(4)])),
      mfaCode: new UntypedFormControl('', Validators.compose([Validators.required])),
      email: new UntypedFormControl('', Validators.compose([Validators.required,Validators.email])),
      phone: new UntypedFormControl('', Validators.compose([Validators.required,Validators.pattern(this.pattern)])),
      preferEmailVerification: new UntypedFormControl(false) 
   });

  }

  openPolicy(event:Event){
    event.stopImmediatePropagation();
    event.preventDefault();
    this.authService.gotoPrivacy();
  }

  onChange(){
  }
  ngOnInit(): void {
  }

  signInWithTwitter() {
    //this.authService.signInWithTwitter()
  }


  signInWithFacebook() {
    /*this.authService.signInWithFacebook()
    .then((res) => {
        this.router.navigate(['dashboard'])
      })
    .catch((err) => console.log(err));*/
  }


  signInWithGoogle() {
    //this.authService.loginWithGoogle(this.chave.value)
  }

  signInWithGithub() {
    /*this.authService.signInWithGithub()
    .then((res) => {
        this.router.navigate(['dashboard'])
      })
    .catch((err) => console.log(err));*/
  }

  async forgotPassword(event:Event) {
    event.stopImmediatePropagation();
    event.preventDefault();
    //this.loaderService.isLoading.next(true);
    this.onSubmit();
    

    await this.authService.forgotPassword(this.username.value,  btoa (this.password.value), this.mfaCode.value, this.mfaSession, this.challengeName, "S", this.preferEmail.value, null).then(m=>{        
      this.credential = m;
      
      this.show2FACodeInput = this.credential.requiresMFA;
      this.showEmailPhone = this.credential.showEmailPhone;          
      this.mfaSession = this.credential.sessionMFA;
      this.challengeName = this.credential.challengeName;

    }, r=>{
      this.firebaseErrorMessage = r;
    }).catch(e=>{
      this.firebaseErrorMessage = e;
    });
  
  }

  disableButton(){
    let retorno = false;
    if ( !this.username.valid || !this.password.valid ){
        retorno = true;
    }

    if ( this.showEmailPhone){
      if ( !this.email.valid || !this.phone.valid ){
          retorno = true;
      }
    }

    if ( this.show2FACodeInput){
      if ( !this.mfaCode.valid){
        retorno = true;
      }
    }

    return retorno;

  }
  

  async signInWithEmail(event:Event, resendSMS:boolean) {

      event.stopImmediatePropagation();
      event.preventDefault();
      //this.loaderService.isLoading.next(true);
      this.onSubmit();
      this.loading = true;

      if(this.show2FACodeInput || this.showEmailPhone){
        await this.authService.loginMFA(this.username.value,  btoa (this.password.value), this.mfaCode.value, this.mfaSession, this.email.value, this.phone.value, this.challengeName, resendSMS).then(m=>{        
          this.credential = m;
          
          this.show2FACodeInput = this.credential.requiresMFA;
          this.showEmailPhone = this.credential.showEmailPhone;          
          this.mfaSession = this.credential.sessionMFA;
          this.challengeName = this.credential.challengeName;

        }, r=>{
          this.firebaseErrorMessage = r;
        }).catch(e=>{
          this.firebaseErrorMessage = e;
        });
      }else{
        await this.authService.login(this.username.value,  btoa (this.password.value), this.preferEmail.value).then(m=>{        
          this.credential = m;

          this.show2FACodeInput = this.credential.requiresMFA;
          this.showEmailPhone = this.credential.showEmailPhone;          
          this.mfaSession = this.credential.sessionMFA;
          this.challengeName = this.credential.challengeName;

        }).catch(e=>{
          let message = GlobalErrorHandler.getMessage(e);
          console.log(message)
          this.firebaseErrorMessage = message;
        }).finally(()=>{
          this.loading = false;
        });
      }
  }

  get username() {
    return this.options.get('username');
  }

  
  get password() {
    return this.options.get('password');
  }

  get mfaCode() {
    return this.options.get('mfaCode');
  }
  
  get email() {
    return this.options.get('email');
  }

  get phone() {
    return this.options.get('phone');
  }

  get preferEmail() {
    return this.options.get('preferEmailVerification');
}

  onSubmit() {
    this.formSubmitAttempt = true;
    
  }
  
}



@NgModule({
    declarations: [
        AuthenticationFormComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NzCardModule,
        NzFormModule,
        NzInputModule,
        NzButtonModule,
        NzCheckboxModule,
        NzIconModule,
        NzAlertModule,
        NgxMaskModule
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AuthModule { }